export default function fixRapOnScroll(
  rapId: string,
  scrollRAPStopId: string,
  scrollRAPTriggerId: string
) {
  const rapElements = document.getElementById(rapId);
  let elementToStopScroll: any =
    document.getElementsByClassName('trigger-stop-rap')[0];
  let elementToStartScroll: any =
    document.getElementsByClassName('trigger-start-rap')[0];
  if (!elementToStopScroll)
    elementToStopScroll = document.getElementById(scrollRAPStopId);

  if (!elementToStartScroll)
    elementToStartScroll = document.getElementById(scrollRAPTriggerId);

  if (elementToStopScroll && elementToStartScroll && rapElements !== null) {
    const elementStopPosition =
      elementToStopScroll.getBoundingClientRect().top + window.scrollY;

    const elementStartPosition = document.getElementsByClassName(
      'trigger-start-rap'
    )[0]
      ? elementToStartScroll.getBoundingClientRect().bottom
      : elementToStartScroll.getBoundingClientRect().top;

    if (window.scrollY + rapElements.offsetHeight > elementStopPosition) {
      const relativeParent: any = rapElements.offsetParent;
      rapElements.classList.add('rap-fixed');
      rapElements.style.position = 'absolute';
      const top =
        elementToStopScroll.offsetTop -
        rapElements.offsetHeight -
        (relativeParent ? relativeParent.offsetTop : 0);
      if (top > 1000) {
        rapElements.style.top = '946px';
      } else {
        rapElements.style.top = `${top - 100}px`;
      }
    } else if (
      window.scrollY > elementStartPosition &&
      window.scrollY + rapElements.offsetHeight < elementStopPosition
    ) {
      rapElements.style.top = '32px';
      const totalHeight =
        document.documentElement.scrollHeight - window.innerHeight;
      if (totalHeight > 169) {
        rapElements.style.position = 'fixed';
        rapElements.classList.add('rap-fixed');
      }
    } else {
      rapElements.style.position = 'unset';
      rapElements.style.minWidth = '392px';
      rapElements.classList.remove('rap-fixed');
    }
  }
}
